import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes.ts'

import { ToursSuccess } from 'pages/payment-success/components/tours-success/components/tours-success'

import searchTour from 'entities/tour/models/search-tour/search-tour.ts'

const SuccessPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    searchTour.resetDataForSearchTour()
    navigate(RoutingPaths.tours.path())
  }

  return (
    <ToursSuccess
      title={t('tours_block.success_title')}
      description={t('tours_block.success_description')}
      buttonText={t('my_orders')}
      onClick={handleClick}
    />
  )
}

export default SuccessPage
